import type { FlaggedContentReport } from "@circle-react/types";
import { Typography } from "@circleco/compass/components/Typography";

import { ReportItem } from "@/react/components/SettingsApp/Moderation/ReportFlaggedContentModal/ReportItem";

interface ReportSectionProps {
  items: FlaggedContentReport[];
  title: string;
}

export const ReportSection = ({ title, items }: ReportSectionProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6">
      <Typography variant="label-xs">{title}</Typography>
      <div className="flex flex-col gap-6">
        {items.map(report => (
          <ReportItem
            key={report.id}
            {...report}
            showStatusBadge
            status={report.status}
          />
        ))}
      </div>
    </div>
  );
};
